// extracted by mini-css-extract-plugin
module.exports = {"heading":"WorkoutHighlights_heading__-pp1T","iconAndText":"WorkoutHighlights_iconAndText__2Lipw","icon":"WorkoutHighlights_icon__2dA8X","text":"WorkoutHighlights_text__1j9ka"};